export default __webpack_public_path__ + "static/media/news231505.81768fb2.jpg";